import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import * as keyboardEventHelpers from 'globals/keyboardEvents';

import { handleRouteToHistory } from '../../app/ChatApp/actions_routing';
import { getCompanyHistorySetting, hasChatSessions } from '../../app/ChatApp/selectors';

import styles from './styles';

export class ChatConversationHeaderMenuButton extends PureComponent {
  handleKeyPress = e => {
    const { handleMenuClick } = this.props;

    if (keyboardEventHelpers.isEnterKey(e)) {
      e.preventDefault();
      e.stopPropagation();

      handleMenuClick();
    }
  };
  render() {
    const { showMenu, handleMenuClick } = this.props;

    if (!showMenu) return null;

    return (
      <div
        tabIndex={0}
        style={styles.wrapper}
        onKeyPress={this.handleKeyPress}
        onClick={handleMenuClick}
        className="kustomer-app-header-menu-button"
        role="button"
      >
        <div className="iconButton backButton" style={styles.icon} />
      </div>
    );
  }
}

ChatConversationHeaderMenuButton.propTypes = {
  handleMenuClick: React.PropTypes.func,
  showMenu: React.PropTypes.bool,
};

ChatConversationHeaderMenuButton.defaultProps = {
  handleMenuClick: () => {},
  showMenu: false,
};

export const mapStateToProps = state => {
  return {
    showMenu: hasChatSessions(state) && getCompanyHistorySetting(state),
  };
};

export const mapDispatchToProps = dispatch => {
  return {
    handleMenuClick() {
      dispatch(handleRouteToHistory());
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ChatConversationHeaderMenuButton);
